import React from 'react';
import './styles/App.css';
import month from './img/sigong_nav/month.png';
import closed from './img/sigong_nav/closed_days.png';
import today from './img/sigong_nav/nav_today.png';
import TopTitle from './TopTitle';
import Bottom_menu from "./Bottom_menu";
import { Link } from 'react-router-dom';
import {resetSession} from './../src/common';

function CalendarChoice() {
    const textStyle = {
        color: '#337ab7',
        fontSize: '17px',
        paddingBottom: '27px'
    }

    return (
        <>
            <TopTitle title="일정 관리" />
            <div className="container mb-5">
                <div className="row">
                    <div className="cs_head text-center">
                        <Link to="/sigong_list" onClick={resetSession}>
                            <div className="mt-5 calendar_imo text-center ">
                                <div>
                                    <img className="calendar_img" src={today}></img>
                                </div>
                                <div style={textStyle}>오늘 일정</div>
                            </div>
                        </Link>
                        <Link to="/month_list" onClick={resetSession}>
                            <div className="mt-3 calendar_imo text-center">
                                <div>
                                    <img className="calendar_img" src={month}></img>
                                </div>
                                <div style={textStyle}>월별 일정</div>
                            </div>
                        </Link>
                        <Link to="/holiday">
                            <div className="mt-3 calendar_imo text-center">
                                <div>
                                    <img className="calendar_img" src={closed}></img>
                                </div>
                                <div style={textStyle}>휴무일 설정</div>
                            </div>
                        </Link>
                        
                        
                    </div>
                </div>
            </div>
            <Bottom_menu />

        </>
    );
}

export default CalendarChoice;